const route = {
    path: "/leave-word",
    meta: {
        isRequiredAuth: true,
        layout: 'PageLayout'
    },
    children: [
        {
            path: "release",
            name: "LeaveWordRelease",
            component: () => import( /*webpackChunkName: "leave-word"*/ "./view/LeaveWordRelease.vue"),
            meta: {
                title: "发布留言",
                isRequiredAuth: true
            }
        },
        {
            path: "index",
            name: "LeaveWordList",
            component: () => import( /*webpackChunkName: "leave-word"*/ "./view/LeaveWordList.vue"),
            meta: {
                title: "留言列表",
                isRequiredAuth: true
            }
        },
        {
            path: "detail",
            name: "LeaveWordDetail",
            component: () => import( /*webpackChunkName: "leave-word"*/ "./view/LeaveWordDetail.vue"),
            meta: {
                title: "留言详情",
                isRequiredAuth: true
            }
        },
        {
            path: "mine-list",
            name: "LeaveWordMineList",
            component: () => import( /*webpackChunkName: "leave-word"*/ "./view/LeaveWordMineList.vue"),
            meta: {
                title: "我的留言",
                isRequiredAuth: true
            }
        },
        {
            path: "mine-detail",
            name: "LeaveWordMineDetail",
            component: () => import( /*webpackChunkName: "leave-word"*/ "./view/LeaveWordMineDetail.vue"),
            meta: {
                title: "我的留言详情",
                isRequiredAuth: true
            }
        }
    ]

}

export default route